export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');
  const swiperWrapper = node.querySelector('.swiper-wrapper');
  let swiperInstance;

  /**
   * Functions
   */
  const initSwiper = () => {
    swiperInstance = new Swiper(swiperContainer, {
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 1.6,
        },
        768: {
          slidesPerView: 4,
        },
      },
    });
  };

  const updateSpreadEvenlyLayout = () => {
    if (!swiperWrapper) return;
    const visibleSlideCount = node.querySelectorAll(
      '.swiper-slide:not(.hidden)'
    ).length;
    const spreadEvenly = visibleSlideCount <= 3;
    swiperWrapper.classList.toggle('md:!flex', spreadEvenly);
    swiperWrapper.classList.toggle('md:!justify-between', spreadEvenly);
    swiperContainer.dataset.blockCount = String(visibleSlideCount);
    swiperContainer.dataset.spreadEvenly = String(spreadEvenly);
  };

  const updateKeyWestSlides = (variantId) => {
    const slides = node.querySelectorAll('[data-key-west-variant-ids]');
    if (!slides.length) return;

    slides.forEach((slide) => {
      const keyWestVariantIds = slide.dataset.keyWestVariantIds
        .split(',')
        .filter(Boolean);
      slide.classList.toggle(
        'hidden',
        keyWestVariantIds.includes(String(variantId))
      );
    });

    updateSpreadEvenlyLayout();
    swiperInstance?.update();
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) initSwiper();

    document.addEventListener('variant:change', (e) => {
      const variantId = e.detail?.variantId;
      if (variantId) updateKeyWestSlides(variantId);
    });
  };

  init();
};
